// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bRXA","buttons":"Footer_buttons__2wfzJ"};